import React, { useMemo } from 'react';

import { type AirdropRule } from '@api/index';
import { USDC } from '@constants/index';
import { helper } from '@utils/index';
import { useUsdRate } from '@widget/airdrop/hooks/useUsdRate';

export type ICache = {
  [key: string]: {
    [key in keyof Omit<AirdropRule, 'releaseNumMax'>]: number;
  }
}

export type IParams = {
  /** 币种 */
  coinCode: string;
  /** 精度 */
  precision: number;
  /** 接口返回的空投发放限制配置的key */
  label: keyof Omit<AirdropRule, 'releaseNumMax'>;
  /** 缓存ref */
  cacheRef: React.MutableRefObject<ICache>;
  /** 接口返回的空投发放限制配置 */
  rules: Partial<Omit<AirdropRule, 'releaseNumMax'>>;
}

type ICalculateValueParams = Omit<IParams, 'label' | 'cacheRef' | 'rules'> & { usdRate: number, num: number };

const calculateValue = ({ num, precision, coinCode, usdRate }: ICalculateValueParams) => {
  let value = helper.formatFixNumString(num, precision)
  if (coinCode !== USDC) {
    value = helper.formatFixNumString(num / usdRate, precision)
  }
  return value;
}

export const useMaxAndMin = ({ coinCode, precision, label, cacheRef, rules }: IParams) => {
  const { usdRate } = useUsdRate({ coinCode });
  return useMemo(() => {
    Object.keys(rules).forEach(rule => {
      const value = calculateValue({ num: rules[rule], precision, coinCode, usdRate });
      cacheRef.current = {
        ...cacheRef.current,
        [coinCode]: {
          ...cacheRef.current?.[coinCode],
          [rule]: value
        }
      }
    })
    return cacheRef.current?.[coinCode]?.[label];
  }, [rules, label, cacheRef, coinCode, precision, usdRate])
}
